export const UserRole = {
  PATIENT: 0,
  CAREGIVER: 1,
  ADMIN: 2,
  PARTNER: 3,
} as const;
